import interact from "interactjs";
import Picker from "vanilla-picker/csp";
import Swal from "sweetalert2";

import {
  applyStyles,
  base64toBlob,
  getElementFromTemplate,
  getPosRelative,
  getRotate,
  openBase64NewTab,
  Toast,
  toggleLoader,
} from "./Utils";
const MM_TO_PX = 3.7795275591;
export class TemplateBuilder {
  constructor() {
    this.initComplete = false;
    this.container = null;
    this.activeElement = null;
    this.canvasSize = { height: 1084, width: 750 }; // Initial A4 with print margins
    this.scale = 1;
    this.canvasBorders = {
      borderLeftWidth: 0,
      borderBottomWidth: 0,
      borderRightWidth: 0,
      borderTopWidth: 0,
    };
    this.$stackBorder = null;

    this.dragElements = null;
    this.templateType = "A4";
    this.layout = "portrait";
    this.borderColor = "#ffffff";
    this.name = null;
    this.id = 0;
    this.hasUnsavedChanges = false;
  }

  init(data) {
    const _this = this;

    // Event listener for the 'beforeunload' event
    window.addEventListener("beforeunload", function (e) {
      // Check if any of the input fields are filled
      if (_this.hasUnsavedChanges) {
        // Cancel the event and show alert that
        // the unsaved changes would be lost
        e.preventDefault();
        e.returnValue = "";
      }
    });
    this.container = document.querySelector("#stack");
    this.$stackBorder = $("#stackBorder");
    this.dragElements = document.querySelector("#dragItems");
    this.colorPicker = new Picker({
      parent: document.querySelector(".color-picker"),
      color: "#000000",
      alpha: false,
      editorFormat: "hex",
    });

    if (data && data.id) {
      this.layout = data.orientation;
      this.name = data.name;
      this.id = data.id;
      this.templateType = data.templateType;
      $("#ddlCanvasSize").val(this.templateType);
      const size = this.getCanvasSize(data.templateType);

      this.canvasSize.height = size.height;
      this.canvasSize.width = size.width;

      this.$stackBorder.css("height", this.canvasSize.height + "px");
      this.$stackBorder.css("width", this.canvasSize.width + "px");

      this.borderColor = data.borderColor;
      this.canvasBorders.borderBottomWidth = data.borderBottomWidth * MM_TO_PX;
      this.canvasBorders.borderLeftWidth = data.borderLeftWidth * MM_TO_PX;
      this.canvasBorders.borderRightWidth = data.borderRightWidth * MM_TO_PX;
      this.canvasBorders.borderTopWidth = data.borderTopWidth * MM_TO_PX;


      $("#ddlLayout").val(this.layout);
      $("[data-style-prop='borderBottomWidth']").val(data.borderBottomWidth);
      $("[data-style-prop='borderLeftWidth']").val(data.borderLeftWidth);
      $("[data-style-prop='borderRightWidth']").val(data.borderRightWidth);
      $("[data-style-prop='borderTopWidth']").val(data.borderTopWidth);
    }
    this.initCanvas();
    this.initDropableElements();

    // Add flag to indicate that the form has been changed
    $(":input")
      .not("#scale")
      .on("change", function (el) {
        _this.hasUnsavedChanges = true;
      });
    this.rescale();
    this.initComplete = true;
  }

  initCanvas() {
    const _this = this;
    //document.querySelectorAll("#canvas").forEach(this.pannable);

    //Set canvas initial size
    _this.$stackBorder.css("height", _this.canvasSize.height + "px");
    _this.$stackBorder.css("width", _this.canvasSize.width + "px");

    $(".border-color-picker").colorPick({
      initialColor: _this.borderColor,
      onColorSelected: function () {
        this.element.css({ 'backgroundColor': this.color, 'color': this.color });
        if (!_this.initComplete) {
          return;
        }
        _this.hasUnsavedChanges = true;
        _this.borderColor = this.color;


        _this.$stackBorder.css(
          "borderLeftColor",
          _this.canvasBorders.borderLeftWidth > 0 ? _this.borderColor : ""
        );
        _this.$stackBorder.css(
          "borderRightColor",
          _this.canvasBorders.borderRightWidth > 0 ? _this.borderColor : ""
        );
        _this.$stackBorder.css(
          "borderTopColor",
          _this.canvasBorders.borderTopWidth > 0 ? _this.borderColor : ""
        );
        _this.$stackBorder.css(
          "borderBottomColor",
          _this.canvasBorders.borderBottomWidth > 0 ? _this.borderColor : ""
        );
      },
    });

    // $("#borderColor").on("change", function () {
    //   // _this.$stackBorder.css("borderColor", $(this).val().toString());

    //   _this.$stackBorder.css(
    //     "borderLeftColor",
    //     _this.canvasBorders.borderLeftWidth > 0
    //       ? $(this).val().toString()
    //       : ''
    //   );
    //   _this.$stackBorder.css(
    //     "borderRightColor",
    //     _this.canvasBorders.borderRightWidth > 0
    //       ? $(this).val().toString()
    //       : ''
    //   );
    //   _this.$stackBorder.css(
    //     "borderTopColor",
    //     _this.canvasBorders.borderTopWidth > 0 ? $(this).val().toString() : ''
    //   );
    //   _this.$stackBorder.css(
    //     "borderBottomColor",
    //     _this.canvasBorders.borderBottomWidth > 0
    //       ? $(this).val().toString()
    //       : ''
    //   );

    //   _this.borderColor = $(this).val().toString();
    // });

    // Init existing template
    var templateElements = document.querySelectorAll(".template-item");

    for (var i = 0; i < templateElements.length; i++) {
      this.initTemplateItem(templateElements[i]);
    }

    // Init text color picker
    _this.colorPicker.onChange = function (color) {
      document.querySelector(".color-picker").style.background =
        color.rgbaString;
      applyStyles(_this.activeElement, { color: color.rgbaString });
    };

    //Scaling
    $("#scale").on("change", function () {
      _this.scale = Number($(this).val());

      _this.rescale();

    });

    //Init font size picker
    $("#ddlFontSize").on("change", function () {
      _this.activeElement.style.fontSize = $(this).val();
    });
    //Init font family picker
    $("#ddlFontFamily").on("change", function () {
      _this.activeElement.style.fontFamily = $(this).val();
      _this.activeElement.setAttribute("data-font", $(this).val());
    });
    // Init style buttons
    $("[data-style-toggle]").on("click", function () {
      const $this = $(this);
      const $el = $(_this.activeElement);
      const styleProp = $this.data("styleToggle");
      const stateOn = $this.data("stateOn");
      const stateOff = $this.data("stateOff");
      const group = $this.data("group");

      const currentState = $el.data("currentState_" + styleProp);

      if (currentState != stateOn) {
        if (group) {
          $(`[data-style-toggle][data-group='${group}']`).removeClass("active");
        }
        $el.css(styleProp, stateOn);
        $el.data("currentState_" + styleProp, stateOn);
        $this.addClass("active");
      } else if (stateOff) {
        $el.css(styleProp, stateOff);
        $el.data("currentState_" + styleProp, stateOff);
        $this.removeClass("active");
      }
    });

    // Init border settings
    $("[data-style-prop]").on("change", function () {
      const $this = $(this);
      _this.$stackBorder.get(0).style[$this.data("styleProp")] =
        $this.val() + "mm";
      _this.canvasBorders[$this.data("styleProp")] =
        MM_TO_PX * Number($this.val());

      _this.$stackBorder.css(
        "borderLeftColor",
        _this.canvasBorders.borderLeftWidth > 0 ? _this.borderColor : ""
      );
      _this.$stackBorder.css(
        "borderRightColor",
        _this.canvasBorders.borderRightWidth > 0 ? _this.borderColor : ""
      );
      _this.$stackBorder.css(
        "borderTopColor",
        _this.canvasBorders.borderTopWidth > 0 ? _this.borderColor : ""
      );
      _this.$stackBorder.css(
        "borderBottomColor",
        _this.canvasBorders.borderBottomWidth > 0 ? _this.borderColor : ""
      );
      _this.reflow();
    });

    $("#ddlCanvasSize").on("change", async function (e) {

      await _this.changesSafeAction(() => {
        const val = $(this).val().toString();
        _this.templateType = val;

        const size = _this.getCanvasSize(val);
        _this.canvasSize.height = size.height;
        _this.canvasSize.width = size.width;

        _this.$stackBorder.css("height", _this.canvasSize.height + "px");
        _this.$stackBorder.css("width", _this.canvasSize.width + "px");

        _this.reflow();
        _this.rescale();
      }, () => {
        $(this).val(_this.templateType);
      });

    });
    $("#ddlLayout").on("change", async function (e) {

      await _this.changesSafeAction(() => {
        _this.layout = $(this).val().toString();

        const size = _this.getCanvasSize(_this.templateType);
        _this.canvasSize.height = size.height;
        _this.canvasSize.width = size.width;

        _this.$stackBorder.css("height", _this.canvasSize.height + "px");
        _this.$stackBorder.css("width", _this.canvasSize.width + "px");
        _this.$stackBorder.attr("data-orientation", _this.layout);
        _this.reflow();
        _this.rescale();
      }, () => {

        $(this).val(_this.layout);
      });


    });

    $("#btnPreview, #btnPreview2").on("click", function () {
      Swal.fire({
        title: "Product barcode for preview",
        input: "text",

        inputPlaceholder: "Barcode",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: false,
        confirmButtonText: "Next",
        showLoaderOnConfirm: true,

        preConfirm: (barcode) => {
          if (barcode) {
            const data = {
              html: $("#stackBorder").get(0).outerHTML,
              barcode: barcode,
              templateType: _this.templateType,
              orientation: _this.layout
            };
            toggleLoader(true);
            $.ajax("/templates/Preview", {
              data: JSON.stringify(data),
              contentType: "application/json",
              type: "POST",
            })
              .then((x) => {
                openBase64NewTab(x.base64Pdf);
                console.log(x);
              })
              .fail((x) => {
                Swal.fire("Error", x.responseText, "error");
              })
              .always(() => {
                toggleLoader(false);
              });
          } else {
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    });



    $("#btnSave, #btnSave2").on("click", function () {
      Swal.fire({
        title: "Template name",
        input: "text",
        inputValue: _this.name,
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Save",
        showLoaderOnConfirm: true,

        preConfirm: (name) => {
          const data = {
            id: _this.id,
            name: name,
            templateType: _this.templateType,
            borderTopWidth: $("[data-style-prop='borderTopWidth']").val(),
            borderRightWidth: $("[data-style-prop='borderRightWidth']").val(),
            borderBottomWidth: $("[data-style-prop='borderBottomWidth']").val(),
            borderLeftWidth: $("[data-style-prop='borderLeftWidth']").val(),
            orientation: _this.layout,
            borderColor: _this.borderColor,
            html: $("#stackBorder").get(0).outerHTML,
          };
          $.ajax("/templates/SaveTemplate", {
            data: JSON.stringify(data),
            contentType: "application/json",
            type: "POST",
          })
            .then((x) => {
              return x;
            })
            .catch((error) => {
              Swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        _this.hasUnsavedChanges = false;
        if (result.isConfirmed) {

          Swal.fire({
            icon: 'success',
            title: 'Saved!',

            timer: 1500,
            timerProgressBar: true,
          });
          //   Toast.fire({
          //     icon: 'success',
          //     title: 'Saved!',
          //     position: 'bottom-end',
          // });
          if (!_this.id) {
            setTimeout(() => {
              window.location = "/templates";
            }, 1000);
          }
        }
      });
    });

    $("#canvas-container").removeClass("invisible");
  }
  async changesSafeAction(action, onDismiss) {
    if (this.hasUnsavedChanges) {
      const result = await Swal.fire({
        title: "Changes may be lost",
        text: "You have unsaved changes. Modifing canvas size may ruin your template",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ignore and continue",
      });

      if (result.isDismissed) {
        onDismiss?.();
      }
      else {
        action();
      }
    }
    else {
      action();
    }
  }
  rescale() {

    $(".scalable").css("scale", this.scale + "");
    const scaledSize = { width: this.canvasSize.width * this.scale, height: this.canvasSize.height * this.scale };
    $(".scalable-wrap").height(scaledSize.height + 'px').width(scaledSize.width + 'px');
  }
  initDropableElements() {
    const position = { x: 0, y: 0 };
    const _this = this;

    interact(".item")
      .draggable({
        manualStart: true,
        listeners: {
          // move: dragMoveListener,
          move(event) {
            position.x += event.dx / _this.scale;
            position.y += event.dy / _this.scale;
            event.target.style.transform = `translate(${position.x}px, ${position.y}px)`;
          },
        },
        modifiers: [
          // interact.modifiers.restrictRect({
          //   restriction: "parent",
          //   endOnly: true,
          // }),
        ],
        //inertia: true,
      })
      // This only gets called when we trigger it below using interact.start(...)
      .on("move", function (event) {
        const { currentTarget, interaction } = event;
        //let element = currentTarget;

        // If we are dragging an item from the sidebar, its transform value will be ''
        // We need to clone it, and then start moving the clone
        if (
          interaction.pointerIsDown &&
          !interaction.interacting() &&
          currentTarget.style.transform === ""
        ) {
          const templateId = currentTarget.getAttribute("data-tmpl");
          let element = getElementFromTemplate(templateId);

          element.style.scale = _this.scale;
          // Add absolute positioning so that cloned object lives
          // right on top of the original object
          element.style.position = "absolute";
          element.style.left = 0;
          element.style.top = 0;

          // Add the cloned object to the document

          _this.makeDragable(element, true);

          _this.dragElements.appendChild(element);

          const { offsetTop, offsetLeft } = currentTarget;
          position.x = offsetLeft / _this.scale;
          position.y = offsetTop / _this.scale;

          element.setAttribute("data-x", offsetLeft * _this.scale);
          element.setAttribute("data-y", offsetTop * _this.scale);
          element.setAttribute("data-tmpl", templateId);

          // If we are moving an already existing item, we need to make sure
          // the position object has the correct values before we start dragging it
          // Start the drag event
          interaction.start({ name: "drag" }, event.interactable, element);
        }
      })
      .on("dragend", function (e) {
        e.currentTarget.remove();
      });

    // Init drop zone
    interact(this.container)
      .dropzone({
        ondrop: function (event) {
          if (!event.relatedTarget.getAttribute("data-clone")) {
            const regex =
              /translate\(([\d]+(?:\.[\d]+)?)px, ([\d]+(?:\.[\d]+)?)px\)/i;
            const transform = regex.exec(event.relatedTarget.style.transform);
            let elementPosition = { top: 0, left: 0 };

            if (transform && transform.length > 1) {
              elementPosition.left = Number(transform[1]);
              elementPosition.top = Number(transform[2]);
            }

            const templateId = event.relatedTarget.getAttribute("data-tmpl");
            var newEl = getElementFromTemplate(templateId);
            _this.container.appendChild(newEl);

            let dropzonePostion = getPosRelative(
              document.querySelector("#stackBorder"),
              document.querySelector("#canvas-container")
            );

            let x =
              Math.max(
                0,
                elementPosition.left - dropzonePostion.left / _this.scale
              ) - _this.canvasBorders.borderLeftWidth;
            let y =
              Math.max(
                0,
                elementPosition.top - dropzonePostion.top / _this.scale
              ) - _this.canvasBorders.borderTopWidth;

            var scaleX =
              newEl.offsetWidth - newEl.getBoundingClientRect().width;
            var scaleY =
              newEl.offsetHeight - newEl.getBoundingClientRect().height;
            x = x + scaleX;
            y = y + scaleY;

            newEl.style.left = `${x}px`;
            newEl.style.top = `${y}px`;

            newEl.setAttribute("data-x", x);
            newEl.setAttribute("data-y", y);
            newEl.setAttribute("data-clone", 1);

            _this.initTemplateItem(newEl);

            interact(newEl).reflow({ name: "drag", axis: "xy" });

            _this.hasUnsavedChanges = true;
          }
        },
      })
      .on("dropactivate", function (event) {
        event.target.classList.add("drop-activated");
      });
  }

  initTemplateItem(newEl) {
    const _this = this;

    this.makeDragable(
      newEl,
      this.isResizeable(newEl.getAttribute("data-type"))
    );

    newEl.addEventListener("click", function () {
      _this.activeElement = this;

      const type = _this.activeElement.getAttribute("data-type");

      // Hide all toolbars first
      $(".text-toolbar").hide();
      if (type === "image") {
      } else if (type.indexOf('text') > -1) {
        $(".text-toolbar").css("display", "flex");
        $("#ddlFontSize").val(_this.activeElement.style.fontSize);
        $("#ddlFontFamily").val(_this.activeElement.getAttribute("data-font"));
        _this.colorPicker.setColor(_this.activeElement.style.color, false);
        $("[data-style-toggle]").each(function () {
          const $el = $(_this.activeElement);
          const $this = $(this);
          const styleProp = $this.data("styleToggle");
          const stateOn = $this.data("stateOn");
          const stateOff = $this.data("stateOff");

          const currentState = $el.data("currentState_" + styleProp);

          if (currentState === stateOn) {
            $this.addClass("active");
          } else {
            $this.removeClass("active");
          }
        });
      }
    });
    this.addDefaultTypeStyle(newEl);
    this.addContextMenu();
  }

  addDefaultTypeStyle(element) {
    const type = element.getAttribute("data-type");
    if (type === "image") {
    } else if (type.indexOf('text') > -1) {
      element.style.fontSize = element.style.fontSize
        ? element.style.fontSize
        : "18px";
      element.style.fontFamily = element.style.fontFamily ? element.style.fontFamily : "Tahoma, sans-serif";
      if (!element.getAttribute("data-font")) {
        element.setAttribute("data-font", "Tahoma, sans-serif");
      }

      element.style.color = element.style.color ? element.style.color : "#000000";
      element.style.textAlign = element.style.textAlign ? element.style.textAlign : "right";

      $(element).data("currentState_textAlign", element.style.textAlign);
    }
  }

  makeDragable(el, resizable) {
    const _this = this;
    const inter = interact(el).draggable({
      listeners: {
        move: (e) => {
          this.dragMoveListener(e);
        },
      },
      inertia: true,
      modifiers: [
        // interact.modifiers.snap({
        //   targets: [
        //     interact.snappers.grid({ x: 10, y: 10 })
        //   ],
        //   range: Infinity,
        //   relativePoints: [ { x: 0, y: 0 } ]
        // }),
        interact.modifiers.restrictRect({
          restriction: "parent",
          offset: { top: 3, left: 3, right: 3, bottom: 3 },
        }),
      ],
    });

    if (resizable) {
      const getResizeModifiers = () => {
        if (resizable === true) {
          return [
            // keep the edges inside the parent
            interact.modifiers.restrictEdges({
              outer: "parent",
            }),

            interact.modifiers.aspectRatio({
              // make sure the width is always double the height
              ratio: el.offsetWidth / el.offsetHeight,
              // also restrict the size by nesting another modifier
              modifiers: [
                interact.modifiers.restrictSize({
                  max: "parent",
                  min: {
                    width: 50,
                    height: 50 / (el.offsetWidth / el.offsetHeight),
                  },
                }),
              ],
            }),
          ];
        } else {
          return [
            // keep the edges inside the parent
            interact.modifiers.restrictEdges({
              outer: "parent",
            }),
            interact.modifiers.restrictSize({ max: "parent" }),
          ];
        }
      };
      inter.resizable({
        // resize from all edges and corners
        edges:
          resizable === true
            ? { left: true, right: true, bottom: true, top: true }
            : resizable,

        listeners: {
          move: (e) => {
            _this.resizeMoveListener(e, resizable === true);
          },
        },
        modifiers: getResizeModifiers(),

        inertia: false,
        margin: 5,
      });
    }
  }

  resizeMoveListener(event, changeHeight) {
    var scaleX =
      this.container.getBoundingClientRect().width / this.container.offsetWidth;
    var scaleY =
      this.container.getBoundingClientRect().height /
      this.container.offsetHeight;
    let { x, y } = event.target.dataset;

    x = (parseFloat(x) || 0) + event.deltaRect.left / scaleX;
    y = (parseFloat(y) || 0) + event.deltaRect.top / scaleY;

    Object.assign(event.target.style, {
      width: `${event.rect.width / scaleX}px`,
      height: changeHeight ? `${event.rect.height / scaleY}px` : undefined,
      left: `${x}px`,
      top: changeHeight ? `${y}px` : undefined,
    });

    Object.assign(event.target.dataset, { x, y });

    this.hasUnsavedChanges = true;
    return;
  }
  dragMoveListener(event) {
    var scaleX =
      this.container.getBoundingClientRect().width / this.container.offsetWidth;
    var scaleY =
      this.container.getBoundingClientRect().height /
      this.container.offsetHeight;

    var target = event.target;
    // keep the dragged position in the data-x/data-y attributes
    var x =
      (parseFloat(target.getAttribute("data-x")) || 0) + event.dx / scaleX;
    var y =
      (parseFloat(target.getAttribute("data-y")) || 0) + event.dy / scaleX;

    const rotate = getRotate(target.style.transform);

    // translate the element
    // target.style.transform = "translate(" + x + "px, " + y + "px) " + (rotate ?? "");
    // target.style.transform = "translate(" + x + "px, " + y + "px) " + (rotate ?? "");

    target.style.left = `${x}px`;
    target.style.top = `${y}px`;

    // update the posiion attributes
    target.setAttribute("data-x", x);
    target.setAttribute("data-y", y);

    this.hasUnsavedChanges = true;
  }

  addContextMenu() {
    $.contextMenu({
      selector: ".template-item",

      items: {
        RotateCV: {
          name: "<span class='mdi mdi-file-rotate-right-outline' style='font-size:20px'></span> Rotate 90°",
          isHtmlName: true,
          callback: function (key, options) {
            var $el = $(this);
            changeDeg($el.get(0), 90);
          },
        },
        RotateCCV: {
          name: "<span class='mdi mdi-file-rotate-left-outline' style='font-size:20px'></span> Rotate -90°",
          isHtmlName: true,
          callback: function (key, options) {
            var $el = $(this);
            changeDeg($el.get(0), -90);
          },
        },

        sep1: "---------",
        Remove: {
          name: "<span class='mdi mdi-close-circle-outline' style='font-size:20px'></span> Remove",
          isHtmlName: true,
          callback: function (key, options) {
            var $el = $(this);
            $el.remove();
          },
        },
      },
    });

    const changeDeg = (el, newDeg) => {
      var re = /(rotate)(\(((.*))(?:deg\)))/g; //regex to match rotateZ(...deg)

      const degE = re.exec(el.style.transform);

      if (
        el.style.transform.match(re) &&
        el.style.transform.match(re).length > 0
      ) {
        const oldDegree = Number(degE[3]);
        newDeg = newDeg + oldDegree;
        el.style.transform = el.style.transform.replace(
          re,
          "$1(" + newDeg + "deg)"
        ); // $1 is first capturing group which is "rotateZ"
      } else {
        el.style.transform += ` rotate(${newDeg}deg)`;
      }
    };
  }
  reflow() {
    const _templateElements = document.querySelectorAll(".template-item");
    for (let i = 0; i < _templateElements.length; i++) {
      interact(_templateElements[i]).reflow({ name: "drag", axis: "xy" });
    }
  }

  getCanvasSize(type) {
    const marginY = 5;
    const marginX = 5;
    const sizeProtrait = { height: (297 - marginY * 2) * MM_TO_PX, width: (210 - marginX * 2) * MM_TO_PX };
    const sizeLandscape = { height: (210 - marginY * 2) * MM_TO_PX, width: (297 - marginX * 2) * MM_TO_PX };

    switch (type) {
      case "A4": // A4 paper (210 mm by 297 mm). //  794 x 1123
        if (this.layout === 'portrait') {
          return { height: sizeProtrait.height, width: sizeProtrait.width };
        }
        else {
          return { width: sizeLandscape.width, height: sizeLandscape.height };
        }

      case "A4/4":
        if (this.layout === 'portrait') {
          return { height: sizeProtrait.height / 4, width: sizeProtrait.width };
        }
        else {
          return { height: sizeLandscape.height / 4, width: sizeLandscape.width };
        }

      case "A5":
        //560 × 795px
        if (this.layout === 'portrait') {
          return { height: sizeLandscape.height, width: sizeLandscape.width / 2 };

        }
        else {
          return { height: sizeProtrait.height / 2, width: sizeProtrait.width };
        }
    }
  }
  isResizeable(type) {

    if (type.indexOf('image') > -1) {
      return true;

    }
    else {

      return { left: true, right: true, bottom: false, top: false };
    }

  }
  pannable = (elViewport) => {

    const elCanvas = elViewport.firstElementChild;
    const start = { x: 0, y: 0 };
    const offset = { x: 0, y: 0 }; // The transform offset (from center)
    let isPan = false;

    const panStart = (ev) => {
      if (elViewport === ev.target) {
        ev.preventDefault();
        ev.stopPropagation();
        isPan = true;
        start.x = ev.clientX - offset.x;
        start.y = ev.clientY - offset.y;
      }
    };

    const panMove = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      if (!isPan) return; // Do nothing
      offset.x = ev.clientX - start.x;
      offset.y = ev.clientY - start.y;
      elCanvas.style.translate = `${offset.x}px ${offset.y}px`;
    };

    const panEnd = (ev) => {
      isPan = false;
    };

    elViewport.addEventListener("mousedown", panStart);
    addEventListener("mousemove", panMove);
    addEventListener("mouseup", panEnd);
  };
}

window.templateBuilder = new TemplateBuilder();
